import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=549859ab&"
import script from "./BaseSlider.vue?vue&type=script&lang=ts&"
export * from "./BaseSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports